import { definePreset } from '@primeuix/themes'
import Material from '@primeuix/themes/material'

export default definePreset(Material, {
    semantic: {
        focusRing: {
            width: 'var(--focus-ring-width)',
            style: 'var(--focus-ring-style)',
            color: 'var(--focus-ring-color)',
            offset: 'var(--focus-ring-offset)',
        },
        colorScheme: {
            light: {
                primary: {
                    color: 'var(--color-primary)',
                    activeColor: 'var(--color-primary-active)',
                    hoverColor: 'var(--color-primary-hover)',
                    contrastColor: 'var(--color-primary-contrast)',
                },
            },
            dark: {
                primary: {
                    color: 'var(--color-primary)',
                    activeColor: 'var(--color-primary-active)',
                    hoverColor: 'var(--color-primary-hover)',
                    contrastColor: 'var(--color-primary-contrast)',
                },
            },
        },
    },
    components: {
        badge: {
            colorScheme: {
                dark: {
                    danger: {
                        color: '#fff',
                        background: '#b71c1c',
                    },
                    success: {
                        color: '#fff',
                        background: '#2e7d32',
                    },
                },
                light: {
                    danger: {
                        color: '#fff',
                        background: 'var(--danger-color)',
                    },
                    success: {
                        color: '#fff',
                        background: 'var(--success-color)',
                    },
                },
            },
        },
        tabs: {
            tab: {
                focusRing: {
                    width: 'var(--focus-ring-width)',
                    style: 'var(--focus-ring-style)',
                    color: 'var(--focus-ring-color)',
                    offset: '-4px',
                },
            },
            colorScheme: {
                dark: {
                    tab: {
                        color: '#fff',
                        activeColor: '#00f4ff',
                        activeBorderColor: '#0cb8ff',
                        activeBackground: '#2d2d49',
                        hoverBackground: 'var(--color-primary-hover)',
                    },
                    tablist: {
                        background: 'var(--surface-color)',
                    },
                    tabpanel: {
                        background: 'var(--surface-color)',
                        color: '#fff',
                    },
                },
            },
        },
        paginator: {
            colorScheme: {
                light: {
                    navButton: {
                        color: '#000',
                        selectedColor: 'var(--paginator-selected-color)',
                    },
                    root: {
                        color: '#000',
                        background: 'var(--surface-color)',
                    },
                },
                dark: {
                    navButton: {
                        color: '#fff',
                        selectedColor: 'var(--paginator-selected-color)',
                    },
                    root: {
                        color: '#fff',
                        background: 'var(--surface-color)',
                    },
                },
            },
        },
        datatable: {
            colorScheme: {
                light: {
                    footer: {
                        background: 'var(--surface-color)',
                    },
                    header: {
                        background: 'var(--surface-color)',
                    },
                    headerCell: {
                        background: 'var(--surface-color)',
                    },
                    row: {
                        background: 'var(--surface-color)',
                    },
                },
                dark: {
                    footer: {
                        background: 'var(--surface-color)',
                    },
                    footerCell: {
                        background: 'var(--surface-color)',
                    },
                    header: {
                        background: 'var(--surface-color)',
                    },
                    headerCell: {
                        background: 'var(--surface-color)',
                        borderColor: '#fff',
                    },
                    row: {
                        background: 'var(--surface-color)',
                    },
                },
            },
        },
        inputtext: {
            root: {
                focusRing: {
                    width: 'var(--focus-ring-width)',
                    style: 'var(--focus-ring-style)',
                    color: 'var(--focus-ring-color)',
                    offset: 'var(--focus-ring-offset)',
                },
            },
            colorScheme: {
                light: {
                    root: {
                        background: '#ffffff',
                        color: '#000000',
                    },
                },
                dark: {
                    root: {
                        background: '#000000',
                        color: '#ffffff',
                    },
                },
            },
        },
        menu: {
            colorScheme: {
                light: {
                    item: {
                        focusBackground: `var(--color-secondary)`,
                        focusColor: '#ffffff',
                        icon: {
                            focusColor: '#ffffff',
                        },
                    },
                },
                dark: {
                    item: {
                        focusBackground: `var(--color-primary)`,
                        focusColor: '#ffffff',
                        icon: {
                            focusColor: '#ffffff',
                        },
                    },
                },
            },
        },
        select: {
            colorScheme: {
                light: {
                    option: {
                        selectedColor: '#ffffff',
                        focusColor: '#ffffff',
                        focusBackground: 'var(--color-secondary)',
                        selectedFocusColor: '#ffffff',
                        selectedBackground: 'var(--color-primary)',
                        selectedFocusBackground: 'var(--color-secondary)',
                    },
                },
                dark: {
                    root: {
                        background: '#000000',
                    },
                    option: {
                        selectedColor: '#ffffff',
                        focusColor: '#ffffff',
                        focusBackground: 'var(--color-primary)',
                        selectedFocusColor: '#ffffff',
                        selectedBackground: 'var(--color-secondary)',
                        selectedFocusBackground: 'var(--color-primary)',
                    },
                },
            },
            root: {
                focusRing: {
                    width: 'var(--focus-ring-width)',
                    style: 'var(--focus-ring-style)',
                    offset: 'var(--focus-ring-offset)',
                    color: 'var(--focus-ring-color)',
                },
            },
        },
        toast: {
            root: {
                width: '310px',
            },
        },
        button: {
            colorScheme: {
                light: {
                    text: {
                        danger: {
                            color: 'var(--danger-color)',
                        },
                    },
                    outlined: {
                        primary: {
                            hoverBackground: '#e7e7e7',
                            activeBackground: '#c3c3c3',
                        },
                        secondary: {
                            color: '#000000',
                            hoverBackground: '#e7e7e7',
                            activeBackground: '#c3c3c3',
                        },
                    },
                    root: {
                        secondary: {
                            color: '#000000',

                            focusRing: {
                                color: 'var(--focus-ring-color)',
                            },
                        },
                    },
                },
                dark: {
                    text: {
                        danger: {
                            color: 'var(--danger-color)',
                        },
                        secondary: {
                            color: '#fff',
                        },
                    },
                    link: {
                        color: '#3366ff',
                        hoverColor: '#5c7dff',
                    },
                    outlined: {
                        primary: {
                            borderColor: '#fff',
                            hoverBackground: 'rgb(255 255 255 / 11%)',
                            color: '#fff',
                        },
                        secondary: {
                            color: '#ffffff',
                            hoverBackground: 'rgb(255 255 255 / 11%)',
                            activeBackground: 'rgb(255 255 255 / 20%)',
                        },
                    },

                    root: {
                        danger: {
                            color: '#EDEDED',
                            hoverColor: '#000',
                            activeBackground: 'var(--p-button-danger-background)',
                        },
                        success: {
                            color: '#fff',
                            hoverColor: '#000',
                            background: '#2d8731',
                        },
                        secondary: {
                            background: '#b3b3b3',
                            hoverColor: '#000000',
                            hoverBackground: '#999999',
                            activeBackground: '#7d7c7c',
                            color: '#000000',

                            focusRing: {
                                color: 'var(--focus-ring-color)',
                            },
                        },
                    },
                },
            },
        },
        menubar: {
            root: {
                background: 'var(--surface-color)',
            },
            mobileButton: {
                color: 'var(--mobile-menu-button-color)',
                size: '48px',

                focusRing: {
                    color: 'var(--focus-ring-color)',
                    width: 'var(--focus-ring-width)',
                    offset: 'var(--focus-ring-offset)',
                    style: 'var(--focus-ring-style)',
                },
            },
            item: {
                focusBackground: 'var(--nav-link-active-background)',
                focusColor: 'var(--nav-link-active-color)',
            },
        },
        textarea: {
            root: {
                focusRing: {
                    color: 'var(--focus-ring-color)',
                    width: 'var(--focus-ring-width)',
                    offset: 'var(--focus-ring-offset)',
                    style: 'var(--focus-ring-style)',
                },
            },
            colorScheme: {
                light: {
                    root: {
                        background: '#ffffff',
                        color: '#000000',
                    },
                },
                dark: {
                    root: {
                        background: '#000000',
                        color: '#ffffff',
                    },
                },
            },
        },
    },
})
